<div class="faq-categories" id="categories">
  @for (category of faqCategories; track category) {
    <a class="category-links" (click)="scrollToCategory(category)">{{category}}</a>
  }
</div>

<div class="row">
  <div class="col-lg-8 col-md-6">
    @for (f of faq; track f; let first = $first) {
      <mat-accordion multi="true">
        <div class="category-heading-wrapper">
          <h1 id="{{f.displayName}}">{{f.displayName}}</h1>
          @if (!first) {
            <a href="javascript:" (click)="scrollToTop()">Top of Page</a>
          }
        </div>
        @for (q of f.questions; track q) {
          <mat-expansion-panel>
            <mat-expansion-panel-header [style.background-color]="primaryBarColor" [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
              <div [innerHtml]="q.question"></div>
            </mat-expansion-panel-header>
            <div [innerHtml]="q.answer"></div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </div>
  <div class="col-lg-4 col-md-6">
    <app-contact-us></app-contact-us>
  </div>
</div>
<!-- removed scroll
todo: see the old code and try to get another one -->
